var table_viewer_default = {
  "viewMode": "_1lwV2",
  "editMode": "WZHbi",
  "container": "a6sYO",
  "cell": "xK8Ex"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
